import { render, staticRenderFns } from "./CardsListUser.vue?vue&type=template&id=139425f5&"
import script from "./CardsListUser.vue?vue&type=script&lang=js&"
export * from "./CardsListUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports